import { FormFieldTypes } from "../../../data/formFieldType";

export const CertificateCorporateListdata = {
  name: "AdditionalInfo",
  initialState: {
    companyNameOrUen: '',
    membershipTypeId: null,
    statusId: null,
  },
  formFields: [
    {
      id: "companyNameOrUen",
      lable: "Company Name/UEN",
      Field_Name: "Company Name/UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyNameOrUen",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "haveapplications",
      lable: "Have applications",
      Field_Name: "Have applications",
      fieldType: FormFieldTypes.SELECT,
      dataField: "haveapplications",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "haveCertifications",
      lable: "Have certifications",
      Field_Name: "Have certifications",
      fieldType: FormFieldTypes.SELECT,
      dataField: "haveCertifications",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
